export { default } from './Accordion';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Accordion/index.js
// module id = 803
// module chunks = 2